import Vue from "vue";
import VueRouter from "vue-router";

import LoginRedirect from "@/components/Login/LoginRedirect.vue";

import Apply from "@/Pages/Apply/Apply.vue";
import Login from "@/Pages/Login/Login.vue";
import ForgotPassword from "@/Pages/ForgotPassword/ForgotPassword.vue";
import ResetPassword from "@/Pages/ResetPassword/ResetPassword.vue";
import UserProfile from "@/Pages/UserProfile/UserProfile.vue";

import AvailableAuPairsContainer from "@/Pages/AvailabeAuPairs/Container.vue";
import Finder from "@/Pages/Finder/Finder.vue";
import AvailableAuPairs from "@/Pages/AvailabeAuPairs/AvailableAuPairs.vue";
import AuPairProfile from "@/components/AuPairs/AuPairProfile.vue";

import FavoriteAuPairs from "@/Pages/FavoriteAuPairs/FavoriteAuPairs.vue";

import RequestInterview from "@/Pages/RequestInterview/RequestInterview.vue";
import CancelInterviewConfirmation from "@/Pages/RequestInterview/CancelInterviewConfirmation.vue";
import InterviewConfirmation from "@/Pages/FavoriteAuPairs/InterviewConfirmation.vue";

import Agreement from "@/Pages/Agreement/Agreement.vue";

import MatchConfirmation from "@/Pages/RequestInterview/MatchConfirmation.vue";
import Matches from "@/Pages/MatchRequest/MatchRequest.vue";

import NotFound from "@/Pages/404/NotFound.vue";

import Dashboard from "@/Pages/Dashboard/Dashboard.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Dashboard,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/user-profile",
    name: "UserProfile",
    component: UserProfile,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/available-au-pairs",
    component: AvailableAuPairsContainer,
    meta: {
      authenticated: true,
    },
    children: [
      {
        path: "",
        name: "AvailableAuPairs",
        component: AvailableAuPairs,
        meta: {
          authenticated: true,
          showStepsHelper: true,
        },
      },
      {
        path: ":id",
        name: "Profile",
        props: true,
        component: AuPairProfile,
        meta: {
          authenticated: true,
        },
      },
    ],
  },
  {
    path: "/favorite-au-pairs",
    name: "FavoriteAuPairs",
    component: FavoriteAuPairs,
    meta: {
      authenticated: true,
      showStepsHelper: true,
    },
  },
  {
    path: "/finder",
    name: "Finder",
    component: Finder,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/interview-confirmation",
    name: "InterviewConfirmation",
    props: true,
    component: InterviewConfirmation,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/request-interview",
    name: "RequestInterview",
    component: RequestInterview,
    meta: {
      authenticated: true,
      showStepsHelper: true,
    },
  },
  {
    path: "/match-request-confirmation",
    name: "MatchConfirmation",
    props: true,
    component: MatchConfirmation,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/cancel-interview",
    name: "CancelInterviewConfirmation",
    props: true,
    component: CancelInterviewConfirmation,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/your-match-request",
    name: "Matches",
    component: Matches,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: Agreement,
    meta: {
      authenticated: true,
    },
  },
  {
    path: "/apply",
    name: "Apply",
    component: Apply,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/login_callback",
    name: "LoginRedirect",
    component: LoginRedirect,
  },
  {
    path: "*",
    name: "404",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.authenticated) {
    if (!window.localStorage.getItem("CHIAuPairAuthToken")) {
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else next();
});

export default router;
